module.exports = __webpack_public_path__ + "static/media/speedy-typer.d81290ef.png";